import { Button, Dialog } from '@buffer-mono/popcorn'

import { getChannelName } from '~publish/helpers/channels'

import { ChannelRefreshCard } from './ChannelRefreshCard'
import type { RefreshableChannel } from './ChannelRefreshCard'

export type ReconnectToLikeDialogProps = {
  channel: RefreshableChannel
  open: boolean
  onOpenChange: (open: boolean) => void
}

/**
 * Asks the user to reconnect a channel that lacks the OAuth scope needed to
 * like mentions. Opened from the mention like button.
 *
 * @see CET-2926
 */
export const ReconnectToLikeDialog = ({
  channel,
  open,
  onOpenChange,
}: ReconnectToLikeDialogProps): JSX.Element => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <Dialog.Content>
      <Dialog.Header>
        <Dialog.Title>Reconnect to like this mention</Dialog.Title>
        <Dialog.Description>
          Refresh your {getChannelName(channel.service)} connection to start
          liking mentions.
        </Dialog.Description>
      </Dialog.Header>
      <Dialog.Body>
        <ChannelRefreshCard
          channel={channel}
          cta="publish-community-reconnectToLike-refresh-1"
        />
      </Dialog.Body>
      <Dialog.Footer>
        <Dialog.Close>
          <Button variant="tertiary">Maybe Later</Button>
        </Dialog.Close>
      </Dialog.Footer>
    </Dialog.Content>
  </Dialog>
)

ReconnectToLikeDialog.displayName = 'ReconnectToLikeDialog'
